import axios from "../../../axios";
import React, { useEffect, useState, useRef } from "react";
import CreateChannelFirst from "../../Create_channel/Create_channel_screen/CreateChannelFirst";
// import ChannelBoxProps from "../../Create_channel/Empty_Screen/Channels_List/ChannelBoxProps";
import ChannelBox from "../../Create_channel/Empty_Screen/Channels_List/ChannelBox";
import CreatePostFirst from "../Create_Post_screen/CreatePostFirst";
import PostImage from "./recent_post Img/PostImage";
import Form from "react-bootstrap/Form";
import "./totalCommuPost.css";
import FilterBox from "./Filter_Box/FilterBox";
import Popup from "reactjs-popup";
import { useSelector } from "react-redux";
import FilterNotFound from "../../../HwManagement/HomeWork/Filter_Box/FilterNotFound";
import "intro.js/introjs.css";
import { Steps } from "intro.js-react";
import CommunityTour from "../../../SidebarHeader/Header/CommunityTour";
import { engagementHomeSteps } from "../../../utils/engagementSteps";
import DetailsImagePopup from "../../PopImage/DetailsImagePopup";
import CommunityImage from "../../../images/Community_Process_Flow.png"
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";

const TotalCommuPost = () => {
  const popupRef = useRef(null);
  const [clickCreate, setClickCreate] = useState(false);
  const [clickPost, setClickPost] = useState(false);
  const [topicPopupOpen, setTopicPopupOpen] = useState(false);
  const [topicList, setTopicList] = useState([]);
  const [allTopics, setAllTopics] = useState([]);
  const [click1, setClick1] = useState(false);
  const [option, setOption] = useState('Initial');
  const [isPostCreated, setIsPostCreated] = useState(false);
  const [postRequestCount, setPostRequestCount] = useState(0);
  const [inProgress, setInProgress] = useState(false);
  const [creater, setCreater] = useState('');
  const currentUser = useSelector((state) => state.user.currentUser);
  const [noContentClick, setNoContentClick] = useState(false);
  const [openImg, setOpenImg] = useState(false)
  const [tagsOptions, setTagsOptions] = useState([])
  const [tagSelectedOption, setTagSelectedOption] = useState(null);
  const [isGettingData, setIsGettingData] = useState(false);
  const [checked, setChecked] = useState({
    sortChecked: 2,
    timeChecked: 1,
  });
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [initialStep, setInitialStep] = useState(0);
  const [homeScreenWalkThroughPopup, setHomeScreenWalkThroughPopup] = useState(false);
  useEffect(() => {
    // Check if the popup has been shown before
    const hasShownPopup = localStorage.getItem("hasShownPopupCommumity");
    if (!hasShownPopup) {
      // Show the steps if it hasn't been shown before
      setHomeScreenWalkThroughPopup(true);
      // Set the flag in localStorage to indicate the popup has been shown
      localStorage.setItem("hasShownPopupCommumity", "true");
    }
  }, []);
  const { state } = useLocation()
  const [steps, setSteps] = useState(engagementHomeSteps);
  const onExit = () => {
    setStepsEnabled(false);
  };
  const [community, setCommunity] = useState([]);
  const [allPost, setAllPost] = useState([]);
  const [searchTopic, setSearchTopic] = useState('');
  const [filter, setFilter] = useState({
    date: null,
    tag: null,
    name: null,
    sortBy: -1,
    time: null,
    limit: 20,
    page: 1,
    searchClick: false,
    topicSearchInput: "",
  });
  const {
    date,
    tag,
    name,
    limit,
    page,
    sortBy,
    time,
    searchClick,
    topicSearchInput,
  } = filter;
  const StudentData = JSON.parse(localStorage.getItem("breathForStudent"));
  const [viewFirstInProgress, setViewFirstInProgress] = useState(false);
  const [postCreatedCount, setPostCreatedCount] = useState(0);
  const [selectedCommunity, setSelectedCommunity] = useState();
  const [filteredTopicList, setFilterTopicList] = useState([]);
  const [comments, setComments] = useState([])
  const loadingRef = useRef(false);
  const lastPageRef = useRef(false);

  const [active, setActive] = useState("About");
  useEffect(() => {

    getCommunity();
    getPostTopic();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCommunity = async () => {
    try {
      const resp = await axios.get(
        `/community/getByUserId/student/${currentUser.id}`
      );
      console.log("resp: ", resp)
      resp && setCommunity(resp.data.data);
    } catch (error) { }
  };

  const getPostTopic = async () => {
    let filterData;
    try {
      let res = await axios.get(
        `/community/post/topic/getByUserId/student/${currentUser.id}`
      );
      if (res) {
        setAllTopics(res.data.data);
        setTopicList(res.data.data);
        setTagsOptions(res.data.data);
      }
    } catch (error) { }
  };

  useEffect(() => {
    let filterData = allTopics.filter((topic) => topic.topic.toLowerCase().includes(searchTopic.toLowerCase()));
    if (searchTopic !== '') {
      setFilterTopicList(filterData);
    }
  }, [searchTopic]);

  useEffect(() => {
    let filterData = allTopics.filter((topic) => topic.topic.toLowerCase().includes(topicSearchInput.toLowerCase()));
    setTopicList(filterData);
  }, [topicSearchInput]);

  useEffect(() => {
    setInProgress(true);
  }, [sortBy, time, searchClick]);

  const handelInfiniteScroll = async () => {
    try {
      if (
        (document.getElementById("total-community-post").clientHeight +
          document.getElementById("total-community-post").scrollTop) +
        1.9 >=
        document.getElementById("total-community-post").scrollHeight
      ) {
        if (!loadingRef.current && !lastPageRef.current) {
          setFilter((prevState) => ({ ...prevState, page: prevState.page + 1 }));
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const element = document.getElementById("total-community-post");
    if (element) {
      element.addEventListener("scroll", handelInfiniteScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener("scroll", handelInfiniteScroll);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter.page, community]);

  const getPostCommunity = async () => {
    try {
      setInProgress(true);
      setIsGettingData(true)
      loadingRef.current = true
      const res = await axios.get(
        `/community/post/getByUserId/student/${currentUser?.id}?_page=${page}&_limit=${limit}&sortBy=${sortBy}` +
        `${name
          ? `&name=${name}`
          : tag
            ? `&tags=${encodeURIComponent(tag)}`
            : date
              ? `&date=${date}`
              : ``
        }` +
        `${time && time !== null ? `&time=${time}` : ``}`
      );
      loadingRef.current = false
      // Total posts fetched so far
      const totalFetchedPosts = allPost.length + res.data.data.length;

      const loadedQuery = Math.min(totalFetchedPosts, res.data.total_post_count);
      // if (loadedQuery > res.data.data.length) {
      //   loadedQuery = allPost.length;
      // }
      if (res.data.data.length == 0 || loadedQuery === res.data.total_post_count) {
        lastPageRef.current = true
      }
      if (page == 1) {
        setAllPost(res.data.data);
      } else {
        setAllPost((prev) => [...prev, ...res.data.data]);
      }
      if (res.data.data.length > 0) {
        toast.info(`Loading Post (${loadedQuery + "/" + res.data.total_post_count})`, {
          position: "bottom-center",
        });
      } else {
        toast.info(`Loaded Post (${loadedQuery + "/" + res.data.total_post_count})`, {
          position: "bottom-center",
        });
      }
    } catch (error) {
      console.log(error);
    }
    setIsGettingData(false)
    setInProgress(false);
  };

  useEffect(() => {
    getPostCommunity();
  }, [limit, page, sortBy, tag, name, time, searchClick, isPostCreated, date]);

  const handelTopicSet = (topic) => {
    setTopicPopupOpen(false);
    lastPageRef.current = false;
    setAllPost([]);
    setFilter({
      ...filter,
      page: 1,
      tag: topic,
      searchClick: !searchClick,
    });
  };
  //mousedown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setTopicPopupOpen(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsPostCreated(false);
    }, 4000);

    return () => clearTimeout(timer);
  }, [isPostCreated]);
  // useEffect(() => {
  //   const getPostComme = async () => {
  //     try {
  //       const res = await axios.get(
  //         `/community/post/${state.post_id}/comment/get?sortBy=-1`
  //       );
  //       let data = [];
  //       res.data.data.map((posts) => {
  //         if (posts.isDeleted) {
  //           if (StudentData?.id === posts?.user_id?.id) {
  //             data.push(posts)
  //           }
  //         } else {
  //           data?.push(posts)
  //         }
  //       })

  //       res && setComments((prev) => [...prev, ...data]);
  //       getPostComme()
  //     } catch (error) {
  //       console.log("error", error)
  //     }
  //   };
  // }, [])

  return (
    <div
      className="overflow-hidden"
    >
      <Steps
        enabled={stepsEnabled}
        steps={steps}
        initialStep={initialStep}
        onExit={onExit}
      />
      <div
        className="w-100 flex gap-3 overflow-hidden"
        style={{ height: "calc(103vh - 180px)" }}
      >
        <div
          className="p-4 d-flex flex-column gap-1"
          style={{
            width: "70%",
            height: "100%",
            backgroundColor: "white",
            overflow: "hidden",
          }}
        >
          <div className="position-relative w-full">
            <div className=" gap-2 p-0 d-flex align-items-center topic_container">
              <span className="open_comu_topic ">Topics</span>
              {/* <div className="topicList d-flex flex-wrap gap-1 mt-2 tagList">
                {topicList?.length > 0 &&
                  topicList.map((item, index) => (
                    <button
                      onClick={() => handelTopicSet(item?.topic)}
                      className="topic_name py-1 px-3"
                      key={index}
                    >
                      {item.topic} {`(${item?.post_count})`}
                    </button>
                  ))}
              </div> */}
              {/* Remove clickable topic */}
              <div className="topicList flex flex-wrap gap-1 mt-2 tagList orange-scrollBar">
                {topicList?.length > 0 &&
                  topicList.map((item, index) => (
                    <span className="topic_name py-1 px-3" key={index}>
                      {item.topic} {`(${item?.post_count})`}
                    </span>
                  ))}
              </div>
              {topicPopupOpen && (
                <div ref={popupRef} className="topic_popup p-3">
                  <div className="topic_list_header d-flex align-items-center justify-content-between mb-3">
                    <span className="topic_label">All Topics</span>
                    <img
                      onClick={(e) => {
                        setTopicPopupOpen(false);
                        setFilter({
                          ...filter,
                          topicSearchInput: "",
                        });
                      }}
                      style={{ cursor: "pointer" }}
                      src="/images/cancel_icon.svg"
                      alt="cancle_icon"
                    />
                  </div>
                  <div className="topic_search_container mb-3 px-2 py-3 d-flex align-items-center">
                    <img className="mr-1" src="/images/search icon.svg" alt="" />
                    <input
                      type="text"
                      placeholder="Search topics"
                      className="topic_search_box"
                      onChange={(e) =>
                        setFilter({ ...filter, topicSearchInput: e.target.value })
                      }
                    />
                  </div>
                  <div className="topic_list">
                    {topicList &&
                      topicList.length > 0 &&
                      topicList.map((item, index) => (
                        <div
                          key={index}
                          onClick={() => handelTopicSet(item?.topic)}
                          className="d-flex mb-1 align-items-center justify-content-between"
                        >
                          <span className="topic_list_name">{item?.topic}</span>
                          <span className="topic_post_count">
                            {item?.post_count} Posts
                          </span>
                        </div>
                      ))}
                  </div>
                </div>
              )}
            </div>
            <div className="d-flex align-items-center filter_containerForComm justify-content-between">
              <div className="mt-2 search_container d-flex align-items-center post_filter justify-content-between  searchAndFilterPosts">
                <div className="dropdown">
                  <Form.Select
                    className="search_dropdown"
                    size="sm"
                    value={option}
                    onChange={(e) => {
                      setOption(e.target.value);
                      if (tag !== null || name !== null) {
                        setFilter({
                          ...filter,
                          name: "",
                          tag: "",
                          page: 1,
                          date: null,
                        });
                      }

                    }}
                  >
                    <option value="Initial">Search by Type</option>
                    <option value="Name">Creator</option>
                    <option value="Tag">Tag</option>
                    {/* <option value="Date">Date</option> */}
                  </Form.Select>
                </div>
                <div className="search_input_cont">
                  {
                    option === "Name" &&
                    <input
                      type="text"
                      className="search_boxs"
                      placeholder="enter name"
                      value={creater}
                      maxLength={50}
                      onChange={(e) => {
                        setCreater(e.target.value);
                      }}
                    />
                  }
                  {
                    option === "Tag" &&
                    <input
                      type="text"
                      className="search_boxs"
                      placeholder="enter tag"
                      value={searchTopic}
                      maxLength={50}
                      onChange={(e) => {
                        setSearchTopic(e.target.value)
                        if (e.target.value == '') {
                          setFilterTopicList([])
                        }
                      }}
                    />
                  }
                </div>
                <img
                  src="/images/search icon black.svg"
                  style={{ cursor: "pointer" }}
                  alt=""
                  onClick={(e) => {
                    setAllPost([]);
                    setFilter({
                      ...filter,
                      date: null,
                      tag: null,
                      page: 1,
                      name: creater,
                      searchClick: true,
                    });
                  }}
                />
                <div className="post_filter_icon d-flex align-items-center justify-content-center mx-1 filterPost">
                  <img
                    src="/images/BlackFilterIcon.svg"
                    alt=""
                    onClick={(e) => setClick1(true)}
                  />
                </div>
              </div>
              <span
                onClick={(e) => {
                  setAllPost([]);
                  setFilter({
                    ...filter,
                    name: "",
                    tag: "",
                    page: 1,
                    date: null,
                    searchClick: !searchClick,
                  });
                  setOption('Initial');
                }}
                className="clearSearch ml-2 clearSearchAndFilter"
              >
                Clear Search
              </span>

              <span
                style={{
                  padding: "5px",
                  backgroundColor: "#45BF55",
                  borderRadius: "6px",
                  color: "#FFFFFF",
                  marginLeft: "30px",
                }}
                onClick={() => window.location.reload()}
                className="refresh cursor-pointer"
              >
                Refresh
              </span>
            </div>
            {option === "Tag" && filteredTopicList.length > 0 && (
              <div
                className="d-flex p-2 align-items-center"
                style={{
                  position: "absolute",
                  backgroundColor: "white",
                  width: "100%",
                  marginTop: "4px",
                  overflow: "scroll",
                  flexWrap: "wrap",
                  gap: 5,
                  zIndex: 100,
                  boxShadow: "10px 8px 38px -17px rgba(0,0,0,0.75)"
                }}
              >
                {
                  filteredTopicList.map((item, index) => (
                    <span
                      key={item?.topic}
                      style={{
                        backgroundColor: "#E5EBEE",
                        color: "#335C76",
                        padding: "5px",
                        borderRadius: "4px",
                        cursor: "pointer"
                      }}
                      onClick={(e) => {
                        setSearchTopic(item?.topic)
                        setTimeout(() => { setFilterTopicList([]) }, 300)
                        lastPageRef.current = false;
                        setAllPost([]);
                        setFilter({
                          ...filter,
                          date: null,
                          name: null,
                          page: 1,
                          tag: item?.topic,
                        });
                      }}
                    >
                      {item?.topic}
                    </span>
                  ))}
              </div>
            )}
            {click1 && (
              <div className="post_filter1">
                <FilterBox
                  setChecked={setChecked}
                  checked={checked}
                  setClick1={setClick1}
                  setFilter={setFilter}
                  filter={filter}
                  setAllPost={setAllPost}
                />
              </div>
            )}
            <div className="flex-wrap  mt-4 d-flex justify-content-between both_container">
              <div id="total-community-post" className="post_box postView orange-scrollBar w-100">
                {
                  allPost?.length > 0 ?
                    <div>
                      {allPost.map((data, idx) => (
                        <PostImage key={idx} post={data} commentLength={(comments.filter((usecomment) => usecomment.user_id.id === StudentData.id || !usecomment.isDeleted)).length} />
                      ))}
                    </div>
                    : !inProgress && <span className="text-center no_post_yet">
                      No posts yet. Be the first one to add a post to community
                    </span>
                }
                {
                  inProgress && <div className="w-100 d-flex justify-content-center align-items-center">
                    <img className="ongoing_loader m-0" src="/gif/LoaderDot.gif" alt="loader" />
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
        <div
          className="px-2 py-2  d-flex flex-column gap-4"
          style={{ width: "30%", height: "100%", backgroundColor: "white" }}
        >
          <div
            className="d-flex flex-column align-items-center justify-content-center w-100 gap-4 py-3 rounded-3"
            style={{ backgroundColor: "#f8f9fb" }}
          >
            <button
              id="open_post_btn"
              class="btn btn-primary post_to_community_button "
              type="button"
              onClick={(e) => setClickPost(true)}
            >
              Post to Community
            </button>
            <div
              onClick={(e) => setOpenImg(true)}
              style={{
                color: "red",
                fontSize: "0.8rem",
                // position: "absolute",
                // left: "35%",
                // top: "45px",
                cursor: "pointer",
              }}
            >
              *Click to Know Details
            </div>
            {isPostCreated && (
              <div className=" p-2 post_successfull">
                <img src="/images/Success.png" alt="" />
                <span className="post_successfull_message">
                  Your post has been posted successfully
                </span>
              </div>
            )}
          </div>
          <div
            className=" mt-2 rounded-3 py-3 px-2"
            style={{ backgroundColor: "#f8f9fb", overflow: "hidden" }}
          >
            <div className="mb-2 d-flex align-items-center justify-content-between channel_createBtn border-b-2 pb-2">
              <span className="channel_header">Channels</span>

              {/* <span
                className="create_channel_btn"
                onClick={(e) => {
                  setClickCreate(true);
                  localStorage.setItem("STUDENT_OPTIONS_STORAGE_KEY", []);
                  localStorage.setItem("TEACHER_OPTIONS_STORAGE_KEY", []);
                }}
              >
                + Create Channel
              </span> */}
            </div>
            <div className="channels_box orange-scrollBar px-2 py-1">
              {/* <ChannelBoxProps /> */}
              {/* <ChannelBox /> */}
              {community && community.length > 0 ? (
                community.map((data, index) => (
                  <ChannelBox
                    key={index}
                    setActive={setActive}
                    postCreatedCount={postCreatedCount}
                    selectedCommunity={selectedCommunity}
                    setViewFirstInProgress={setViewFirstInProgress}
                    viewFirstInProgress={viewFirstInProgress}
                    postRequestCount={postRequestCount}
                    communityData={data}
                  />
                ))
              ) : (
                <div className="no-channel">No Channel Available Yet.</div>
              )}
            </div>
          </div>
        </div>

      </div>


      {clickPost && (
        <CreatePostFirst
          setAllPost={setAllPost}
          setChoosedCommunity={setSelectedCommunity}
          setPostCreatedCount={setPostCreatedCount}
          setIsPostCreated={setIsPostCreated}
          setClickPost={setClickPost}
          setFilter={setFilter}
          getPostCommunity={getPostCommunity}
          clickPost={clickPost}
        />
      )}
      {homeScreenWalkThroughPopup && (
        <CommunityTour
          setHomeScreenWalkThroughPopup={setHomeScreenWalkThroughPopup}
          setStepsEnabled={setStepsEnabled}
        />
      )}
      {
        openImg && <DetailsImagePopup setOpenImg={setOpenImg} imgSrc={CommunityImage} />
      }
    </div>
  )
};

export default TotalCommuPost;
